import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useContext, useState } from "react"
import { Link, useNavigate, useParams } from "react-router"
import API from "./API";
import { AdminOrderPersonsResponse, AdminQueryOrder, AdminQueryProject } from "../../backend/src/api/dto";
import { useForm } from "react-hook-form";
import ModalConfirmation from "./Modal/Confirmation";
import { ModalContext } from './ModalContext';
import AdminAddUserToOrder from "./Modal/AdminAddUserToOrder";
import { AdminAddPersonToOrderFunction } from "./interfaces";
import AdminLevel from "./AdminLevel";

type FormValues = {
    name: string
    description: string
    withActivities: boolean | number
    visible: boolean | number
}


function ProjectOrder() {

    const params = useParams();
    let navigate = useNavigate();
    const [loading, setLoading] = useState(true)
    const [showModal, closeModal] = useContext(ModalContext);

    const [data, setData] = useState<{
        project: AdminQueryProject | { name: '' },
        order: AdminQueryOrder | { name: '' }
        orderPersons: AdminOrderPersonsResponse[]
    }>({
        project: { name: '' },
        order: { name: '' },
        orderPersons: []
    })

    const { register, control, handleSubmit, getValues, } = useForm<FormValues>({
        defaultValues: async () => {

            const projectOrder = await API.getProjectOrder(params.projectId ?? 0, params.orderId ?? 0)
            setData(projectOrder)
            setLoading(false)
            return projectOrder.order

        }

    })

    const [sending, setSending] = useState(false);
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)



    const reloadData = () => {
        return API.getProjectOrder(params.projectId ?? 0, params.orderId ?? 0).then(projectOrder => {
            setData(projectOrder)
        })
    }

    const removePerson = (personId: number) => {
        return API.removePersonFromOrder(params.projectId ?? 0, params.orderId ?? 0, personId).then(() => {
            return reloadData()
        });
    }

    const addPerson: AdminAddPersonToOrderFunction = (personId, startDate, endDate) => {
        return API.addPersonToOrder(params.projectId ?? 0, params.orderId ?? 0, personId, startDate, endDate)
    }

    const saveProjectOrder = () => {
        return API.saveProjectOrder(params.projectId ?? 0, params.orderId ?? 0, getValues()).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/project/' + params.projectId)
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    const deleteProjectOrder = () => {
        return API.deleteProjectOrder(params.projectId ?? 0, params.orderId ?? 0).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/project/' + params.projectId)
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    if (loading) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>
                        <div className="mt-2">Projekt: ...</div>
                    </div>
                    <div className="card-body">
                        Nahrávam
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header " style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-1">
                            <span className=""><Link to={"/dashboard/project/" + params.projectId} className="btn btn-primary"><FontAwesomeIcon fixedWidth icon={["fas", "arrow-left"]} /> Späť</Link></span>
                        </div>
                        <div className="col-6">
                            <div className="mt-2">Projekt: <strong>{data.project.name}</strong> <FontAwesomeIcon fixedWidth icon={["fas", "chevron-right"]} className="text-secondary me-3 ms-3" /> Komponent: <strong>{data.order.name}</strong></div>
                        </div>
                        <div className="col-5 text-end">
                            <AdminLevel level={9} match="greaterOrEqual">
                                {
                                    !loading && !data.orderPersons.length ?
                                        <button className="btn btn-danger me-3" onClick={() => showModal(
                                            <ModalConfirmation
                                                confirm={deleteProjectOrder}
                                                title={"Naozaj zmazať komponent?"}
                                                text="" />
                                        )}><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} />  Zmazať komponent</button>
                                        : null
                                }
                                <button className="btn btn-primary" onClick={saveProjectOrder}><FontAwesomeIcon fixedWidth icon={["fas", "floppy-disk"]} />  Uložiť komponent</button>
                            </AdminLevel>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <form style={{ minHeight: '300px' }}>
                                <div className="row">
                                    <div className="col-3 mt-1 text-end">
                                        <label className="form-label">Názov</label>
                                    </div>
                                    <div className="col-9">
                                        <input type="text" {...register("name")} className="form-control form-control-sm" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-3 mt-1 text-end">
                                        <label className="form-label">Popis</label>
                                    </div>
                                    <div className="col-9">
                                        <textarea rows={6} {...register("description")} className="form-control form-control-sm" />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="offset-3 col-9">
                                        <div className="form-check">
                                            <input className="form-check-input" {...register("withActivities")} type="checkbox" />
                                            <label className="form-check-label">
                                                s Aktivitami
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="offset-3 col-9">
                                        <div className="form-check">
                                            <input className="form-check-input" {...register("visible")} type="checkbox" />
                                            <label className="form-check-label">
                                                Viditeľné
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>


                    <div className="card mt-5">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-6">
                                    <div className="mt-1"><span className="text-primary me-2"><FontAwesomeIcon fixedWidth icon={["fas", "puzzle-piece"]} /><FontAwesomeIcon fixedWidth icon={["fas", "arrow-right"]} /><FontAwesomeIcon fixedWidth icon={["fas", "person"]} /></span> Osoby priradené ku komponentu</div>
                                </div>
                                <div className="col-6 text-end">
                                    <button className="btn btn-success btn-sm" onClick={
                                        () => showModal(
                                            <AdminAddUserToOrder
                                                item={null}
                                                reload={reloadData}
                                                alreadyAdded={data.orderPersons}
                                                addFunction={addPerson}
                                            />
                                        )
                                    }><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať osobu ku komponentu</button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <table className="table table-bordered table-sm">
                                <thead>
                                    <tr>
                                        <th>Meno</th>
                                        <th className="text-center" style={{ width: '100px' }}>Od</th>
                                        <th style={{ width: '20px' }}></th>
                                        <th className="text-center" style={{ width: '100px' }}>Do</th>
                                        <th className="text-center" style={{ width: '120px' }}>Akcia</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        data.orderPersons.sort((a, b) => Number(b.continuity) - Number(a.continuity)).map(person => {
                                            return (
                                                <tr>
                                                    <td>{person.name} {person.surname}</td>
                                                    <td>{person.fromMonth}&nbsp;.&nbsp;{person.fromYear}</td>
                                                    <td className={person.continuity ? 'bg-success-subtle' : 'bg-danger-subtle'}></td>
                                                    <td>{
                                                        !person.toMonth || !person.toYear ?
                                                            'Trvá' : <span>{person.toMonth}&nbsp;.&nbsp;{person.toYear}</span>
                                                    }</td>
                                                    <td className="text-center">
                                                        <button className="btn btn-danger btn-sm me-2" onClick={
                                                            () => showModal(
                                                                <ModalConfirmation
                                                                    confirm={() => removePerson(person.personId)}
                                                                    title="Potvrdiť odobratie"
                                                                ><div>
                                                                        <table className="table table-bordered">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>Osoba</td>
                                                                                    <td>{person.name} {person.surname}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>Komponent</td>
                                                                                    <td>{getValues().name}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </ModalConfirmation>
                                                            )
                                                        }><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} /> Odobrať</button>

                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}


export default ProjectOrder







